module.exports = __webpack_public_path__ + "static/ATF-d7abf1e990384e08610ebdc1adb68828.jpg";